import React from 'react';
export const CFIconTrendingUp = {
    alias: 'trending-up',
    defaultTitle: 'Trending Up',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M20.992 6.963c-.002-.072-.023-.14-.041-.209-.015-.058-.023-.117-.047-.17-.023-.052-.063-.094-.096-.142-.043-.061-.08-.122-.134-.172-.01-.009-.014-.021-.023-.029-.037-.031-.08-.042-.12-.067-.06-.039-.118-.079-.186-.105-.067-.024-.133-.03-.203-.04C20.095 6.022 20.052 6 20 6h-5a1 1 0 1 0 0 2h2.826l-4.036 4.708-4.275-2.565a.997.997 0 0 0-1.284.217l-5 6a1 1 0 0 0 1.538 1.28l4.451-5.342 4.265 2.56a1 1 0 0 0 1.274-.207L19 9.703V12a1 1 0 1 0 2 0V7c0-.013-.006-.024-.008-.037Z' }))),
};
